import React from 'react';

const LinkedInIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>;

const TEAM = [
    {
        role: 'Founder & CEO', name: 'Mark Bernstein', linkedin: 'https://www.linkedin.com/in/markbernstein',
        img: require('../../../../images/landing-pages/about-us/mark-picture.png'), photoBg: '#EEF1FF',
        bullets: [
            'Chartered Accountant, 30+ years across startups, VC-backed and LSE/AIM-listed companies',
            '4 IPOs including two unicorns — GeoCities sold to Yahoo! for $4.3bn',
            '25 M&A transactions as founder, CFO, chair and NED',
            'Wearable Technologies sold to Blackline Safety Corp (TSX) 2021',
        ],
    },
    {
        role: 'Chief Technology Officer', name: 'Jon Bradshaw', linkedin: 'https://www.linkedin.com/in/jmbradshaw',
        img: require('../../../../images/landing-pages/about-us/jonpicture.png'), photoBg: '#EEF1FF',
        bullets: [
            'Fractional and full-time CTO across B2B SaaS, health, pharma, adtech, and web3',
            "Named inventor on multiple patents; built the world's first online Fantasy Football game",
            'VP Engineering, Elliptic (crypto AML); CTO, FITFILE (real-world health evidence)',
        ],
    },
];

const AboutTeamSlider = () => (
    <section id="team" className="lp-about-team">
        <div className="lp-container">
            <div className="lp-badge" data-lp-reveal><span />The team</div>
            <div className="lp-about-team-head">
                <h2 className="lp-h2" data-lp-reveal>Meet the people behind Diligentsia.</h2>
                <p className="lp-sub" data-lp-reveal data-lp-delay="60">Operators, investors, and technologists who've done it before.</p>
            </div>

            <div className="lp-about-team-list">
                {TEAM.map((p, i) => (
                    // Reason: odd cards mirror to photo-left so the stacked pair reads as one composition.
                    <article className={`lp-about-person-card${i % 2 ? ' lp-about-person-card--flip' : ''}`} key={i} data-lp-reveal data-lp-delay={i * 120}>
                        <div className="copy">
                            <div className="role">{p.role}</div>
                            <h3>{p.name}</h3>
                            <a className="li" href={p.linkedin} target="_blank" rel="noopener noreferrer"><LinkedInIcon />LinkedIn</a>
                            <div className="bullets">
                                {p.bullets.map((b, j) => <div key={j}><span>→</span><span>{b}</span></div>)}
                            </div>
                        </div>
                        <div className="photo" style={{ background: p.photoBg }}>
                            <img src={p.img} alt={p.name} />
                        </div>
                    </article>
                ))}
            </div>
        </div>
    </section>
);

export default AboutTeamSlider;
